import EarningReportComponent from 'components/Report/EarningReport';
import PermissionGuard from 'components/Global/PermissionGuard'; // adjust path if needed

const EarningReport = () => {
	return (
		<PermissionGuard permission="Allow_Earning_and_Deduction_Reports">
			<EarningReportComponent />
		</PermissionGuard>
	);
};

export default EarningReport;
